<mat-progress-bar *ngIf="timerEnabled" class="progress-bar" [color]="color" [mode]="mode" [value]="percentProgressBar">
</mat-progress-bar>

<div class="simple-dialog">
  <button mat-dialog-close mat-icon-button aria-label="close dialog" class="close-button">
    <mat-icon>close</mat-icon>
  </button>

  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content>
    <p>{{ message }}</p>
  </div>

  <div mat-dialog-actions>
    <button
      *ngFor="let button of buttons"
      mat-button
      [ngClass]="button.raised && 'mat-raised-button'"
      [color]="button.color"
      (click)="close(button.action)"
    >
      {{ button.text }}
    </button>
  </div>
</div>
